<template>
  <span
    :data-testid="dataTestid"
    class="rounded-[4px] empty:hidden font-bold"
    :class="[component.color, {'text-2xxs px-1 py-0.5 leading-normal': size === 'extra-small', 'inline-flex px-2 py-[2px] text-xs': size === 'small', 'inline-flex px-2 py-[2px] text-sm': size === 'standard'}]"
  >
    <slot v-if="$slots.default" />
  </span>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsTag'
})

const props = defineProps({
  color: {
    type: String,
    default: 'white',
    validator: value => [
      'bordered', 'white', 'gray', 'green', 'pink', 'yellow', 'purple', 'purpled',
      'purplebd', 'blue', 'blue-crayola', 'blueb', 'darkb', 'cyanb', 'cyan', 'brown',
      'whiteb', 'grayb', 'successb', 'successbd', 'yellowb', 'errorb', 'errorbd',
      'orange', 'orangebd', 'disclaimer', 'deep-purple','seafoam','pink','tangerine',
      'rose-pink', 'blue-cloud', 'peach'
    ].includes(value)
  },
  size: {
    type: String,
    default: 'standard',
    validator: value => ['standard', 'small', 'extra-small'].includes(value)
  },
  dataTestid: {
    type: String,
    default: ''
  }
})

const { dataTestid } = toRefs(props)

const component = computed(() => {
  const color = getKey(props.color, {
    bordered: 'text-semantic-surface-on-surface bg-semantic-surface-container-lowest border-semantic-surface-on-surface border-solid border-1',
    white: 'text-semantic-surface-on-surface bg-semantic-surface-container-lowest',
    gray: 'bg-gray-600 text-dark',
    green: 'bg-semantic-primary-default text-semantic-inverse-primary',
    pink: 'bg-semantic-inverse-primary text-inverse-on-primary',
    yellow: 'bg-semantic-inverse-primary text-semantic-surface-on-surface',
    purple: 'bg-purple-70 text-white',
    purpled: 'bg-purple-80 text-white',
    'deep-purple': 'bg-purple-100 text-white',
    purplebd: 'bg-purple-700 backdrop-opacity-5 text-semantic-surface-on-surface border-1 border-solid border-purple-70',
    blue: 'bg-alert-info-fill text-semantic-surface-on-surface',
    'blue-crayola': 'bg-blue-500 text-white',
    blueb: 'bg-alert-info-fill text-semantic-surface-on-surface border-1 border-solid border-alert-info-stroke',
    darkb: 'bg-white text-semantic-surface-on-surface border-1 border-solid border-semantic-surface-on-surface',
    cyanb: 'bg-cyan-600 text-semantic-surface-on-surface',
    cyan: 'bg-alert-info-fill border-1 border-solid border-cyan-600 text-cyan-600',
    brown: 'bg-[#9A5533] text-white',
    whiteb: 'bg-white text-semantic-surface-on-surface border-1 border-solid border-blue-900',
    grayb: 'bg-gray-10 text-semantic-surface-on-surface border-1 border-solid border-gray-400',
    successb: 'bg-alert-success-fill text-primary border-1 border-solid border-primary',
    successbd: 'bg-alert-success-fill text-semantic-surface-on-surface border-1 border-solid border-primary',
    yellowb: 'bg-alert-warning-fill text-semantic-surface-on-surface border-1 border-solid border-alert-warning-stroke',
    errorb: 'bg-alert-error-fill text-danger border-1 border-solid border-alert-error-stroke',
    errorbd: 'bg-alert-error-fill text-semantic-surface-on-surface border-1 border-solid border-alert-error-stroke',
    orange: 'bg-orange-650 text-white',
    orangebd: 'bg-orange-750 text-semantic-surface-on-surface border-1 border-solid border-orange-700',
    disclaimer: 'bg-gray-80 text-white',
    'seafoam': 'bg-semantic-vertical-insurance-low semantic-surface-on-surface',
    'rose-pink': 'bg-base-rose-rose semantic-surface-on-surface',
    'tangerine': 'bg-base-oat-600 semantic-surface-on-surface',
    'blue-cloud': 'bg-semantic-states-info-variant text-semantic-surface-on-surface',
    peach: 'bg-semantic-vertical-finance-low text-semantic-inverse-on-primary-variant'
  })

  return {
    color
  }
})
</script>